import { call, put, takeLatest } from 'redux-saga/effects';
import RedeemActions from '../actions/RedeemActions';
import UserActions from '../actions/UserActions';
import RedeemApi from '../apis/RedeemApi';

function* redeem(action) {
    try {
        const params = action.payload;
        const memberList = yield call(RedeemApi.redeem, params);
        yield put(RedeemActions.redeemSuccess({ memberList }));
        yield put(UserActions.updateStatus());
    } catch (e) {
        console.info('Failed to redeem: ', e);
        yield put(RedeemActions.redeemFailed(e));
    }
}

function* RedeemSaga() {
    yield takeLatest(RedeemActions.TYPES.REDEEM, redeem);
}

export default RedeemSaga;
